import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Hanger.svg",
  "use": "Hanger.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Hanger.svg\"><path d=\"M7.9922,48a2,2,0,0,1-1.2089-3.5934l27.02-20.4994a3.0173,3.0173,0,0,0,1.1868-2.39V19a3,3,0,1,0-5.9994,0,2,2,0,1,1-4,0A7,7,0,1,1,38.99,19v2.5171a7.039,7.039,0,0,1-2.7688,5.5767l-.9118.6918L57.2168,44.4067A2,2,0,0,1,56.0079,48Zm42.071-4L32,30.296,13.9369,44Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol